var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBank(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 43,
    height: 42,
    viewBox: "0 0 43 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "bank",
    transform: "translate(-824 -401)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_15",
    "data-name": "Ellipse 15",
    cx: 21.5,
    cy: 21,
    rx: 21.5,
    ry: 21,
    transform: "translate(824 401)",
    fill: "#3a55f8"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2_",
    transform: "translate(835.111 412)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_4_",
    d: "M.953,8.269h.954v6.36H3.815V8.269H7v6.36H8.9V8.269h3.18v6.36h1.908V8.269h3.18v6.36h1.908V8.269h.954a.954.954,0,0,0,.529-1.748L11.022.162a.954.954,0,0,0-1.058,0L.424,6.521A.954.954,0,0,0,.953,8.269Z",
    transform: "translate(0.001 -0.002)",
    fill: "#fcfcfc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5_",
    d: "M20.034,260H.955a.954.954,0,0,0-.954.954V263.5a.954.954,0,0,0,.954.954H20.034a.954.954,0,0,0,.954-.954v-2.544A.954.954,0,0,0,20.034,260Z",
    transform: "translate(-0.001 -243.466)",
    fill: "#fcfcfc"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBank);
export default __webpack_public_path__ + "static/media/bank.09682eb0163acbfaaf3baca239ef305e.svg";
export { ForwardRef as ReactComponent };